<template>
    <v-form v-model="form" ref="form_step_1">
        <contact-information :validation-id="v__validationId" class="mt-5" ></contact-information>
        <dates-of-rental :validation-id="v__validationId" class="mt-5"></dates-of-rental>
        <steps-navigation :errors="v__getErrors()" :back-button="false" @step-next="stepNext"></steps-navigation>
    </v-form>
</template>

<script>
import ValidatableComponent     from "../../../mixins/ValidatableComponent";
import reservation_form__fields from "../../../validation/fields/reservation_form__fields";
import reservation_form__rules  from "../../../validation/scenarios/reservation_form__rules";
import reservation_canadian_form__rules  from "../../../validation/scenarios/reservation_canadian_form__rules";
import DatesOfRental            from "./step1/DatesOfRental";
import ContactInformation       from "./step1/ContactInformation";
import StepsNavigation          from "../../../components/partials/StepsNavigation";
import {mapActions}             from "vuex";
import StepperComponentMixin    from "../../../mixins/StepperComponentMixin";
import UiManagerMixin           from "../../../mixins/UiManagerMixin";
import reservation_form_with_location__rules from "../../../validation/scenarios/reservation_form_with_location__rules";

export default {

    name: "Step1",
    components: {StepsNavigation, ContactInformation, DatesOfRental},
    mixins: [StepperComponentMixin,ValidatableComponent, UiManagerMixin],
    data: () => ({
        form: false,
    }),
    methods: {
        ...mapActions(['do_save_reservation', 'do_save_reservee', 'do_calculate_kiosk_cost']),
        async stepSubmit() {
            if(!parseInt(this.$store.state.resources.config.reservee_gender)){
                this.$store.commit('set_model_value',{path:'model.reservation.gender_is_on',value: 0})
            }
            try {
                const result = await this.do_save_reservation();
                // await this.do_save_reservee()
                await this.do_calculate_kiosk_cost();
                return  true;
            } catch (e) {
                if (e.isCustomError) {
                    switch (e.type) {
                        case 'validation':
                            for (let attr in e.data.errors) {
                                 this.addErrors(e.data.errors[attr].map(e => ({attr,message:e})));
                            }
                            break;
                    }
                }
                console.log(e);

            }
            return false;
        }
    },
    computed : {
        useCoupons () {
            return this.$store.state.resources.config.use_coupons;
        },
        return_customer_kiosk(){
            return parseInt(this.$store.state.resources.config.return_customer_kiosk);
        },
        return_customer_seasonal_reservation(){
            return parseInt(this.$store.state.resources.config.return_customer_seasonal_reservation);
        },
        welcome_text_in_advance() {
            return parseInt(this.$store.state.resources.config.welcome_text_in_advance);
        }
    },
    mounted() {
        if((!this.$store.state.model.reservation.is_seasonal && this.return_customer_kiosk) || ((this.$store.state.model.reservation.is_seasonal || window.location.href.includes('seasonal')) && this.return_customer_seasonal_reservation)){
            this.ui__openModalByName({name:'dialog_return_customer'})
        }
        if(this.$store.state.model.reservation.is_seasonal && window.location.href.includes('seasonal')){
            this.$store.commit('set_model_value', {path: 'model.reservation.is_from_kiosk', value:0})
            this.$store.commit('set_model_value', {path: 'model.reservation._type', value:'advance'})
            if(this.welcome_text_in_advance){
                this.ui__openModalByName({name:'dialog_welcome_text'})
            }
        }
        const self = this;
        this.withValidation({
            getModel() {
                return self.$store.state.model.reservation;
            },
            rules : parseInt(this.$store.state.resources.config.is_international_canadian)?reservation_canadian_form__rules:(this.$store.state.resources.config.frontend_view_folder=="frontend.adventure" && window.location.href.includes('seasonal'))? reservation_form_with_location__rules:reservation_form__rules,
            fields: reservation_form__fields
        })
    }

}
</script>

<style scoped>

</style>
